import { useContractRead } from 'wagmi';
import { BitstraysSeederABI } from '@bitstrays/contracts';
import { parseSeed } from './bitstrayToken';
import config from '../config';

const contractConfig = {
  address: config.addresses.bitstraysSeeder as `0x${string}`,
  abi: BitstraysSeederABI,
};

export const useBitstraySeedCandiate = (bitstrayId: bigint) => {
  const { data: seed } = useContractRead({
    ...contractConfig,
    functionName: 'generateSeed',
    args: [bitstrayId, config.addresses.bitstraysDescriptor as `0x${string}`],
    enabled: !!bitstrayId,
    watch: true, // Watch for block changes to update the seed candidate
  });
  return parseSeed(seed);
};
